module.exports = __webpack_public_path__ + "img/logo.a82a4523.jpg";